<template>
<div class="chapter">
<div class="inner_page">
<div class="part_color">
<p class="PartNo" id="p01">Part  <span class="txt_white">I</span></p>
<p class="PartTitle" id="pt01">The Method</p>
<p class="txt"><i>First things first—what is foundation paper piecing? How do you sew on paper? Do you need special tools?</i></p>
<p class="txt"><i>In this first section, I walk you through the method I’ve developed for all my paper-piecing escapades, covering everything you need to know to go from cryptic lines and numbers on paper to a finished fabric block.</i></p>
</div>
<p class="figure"><img alt="" src="images/pg10_2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_part01.vue?6644ff57